<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.jpg" width="100%"  />
	</div>
</div>

<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:50px;">
         <div class="tit3"><em><a @click="goHome()">返回首页>></a></em><span>举报单位</span></div>
       
        <div class="m_t_20 main-box">
          <div style="width:40px; height:100%; float:left; border-right:1px solid #ddd; font-size:24px; color:#333; line-height:24px; padding:42px 24px; text-align:center;"><b>反馈信息查询</b><br /></div>
          <div class="f-left">
           <div class="main-box2" style="padding:60px 30px;">
                <form action="" method="post" class="bootstrap-frm2 t-center" style="margin:0 auto;"><!-- 修改 class 名称 对应效果 -->
                  <div class="overf">
                  <label style="width:100%;"> <span>信息查询码 :</span>
                    <input id="queryCode" type="text" name="queryCode" placeholder=" " style="width:690px;" v-model="loginForm.queryCode"/>
                  </label >
                   <label style="width:100%;"> <span>验证码 :</span>
                    <input
                      type="text"
                      style="width:200px"
                      name="code"
                      v-model="loginForm.code"
                      autoComplete="on"
                      placeholder="请输入右边的验证码"
                    /><img
                      @click="handleGetLoginCode"
                      :src="captcha+'/captcha/query?uuid='+loginForm.uuid"
                      alt=""
                    >
                  </label >
                  
                  </div>  
                </form>
          </div>
        </div>  
	</div>
                <div class="m_t_30" style=" text-align:center;">
                 <a @click="query()" class="button button-caution button-rounded button-large " style="background:#a00; margin-left:50px;">查询信息处理状态</a>
                </div>

</div>
</div>



<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
              <p class=" p_l_10 ">
Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			  </p>
        <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      captcha:process.env.BASE_API,
      loginForm: {
        queryCode: '',
        code: '',
        uuid:'',
      },
    }
  },
  mounted(){
    this.ddd=this.captcha
  },
  created(){
     this.handleGetLoginCode() //更新uuid生产验证码
  },
  methods:{
      notice(code){
          this.$router.push({name:'notice',params:{areaCode:code}})
      },
      //生成验证码uuid
      handleGetLoginCode() {
          this.loginForm.uuid = Date.now().toString()
      },
      query(){
        if(this.loginForm.queryCode.trim()===''){
          alert("请输入查询码")
          return false;
        }
        if(this.loginForm.code.trim()===''){
          alert("请输入验证码")
          return false;
        }
    
        request({
              url: '/org-report/reply',
			        method: 'get',
              params: this.loginForm
            }).then((res)=>{
              console.log(res)
              this.$router.push({name:'queryResult',params:{queryCode:this.loginForm.queryCode,
                                      code:this.loginForm.code,
                                      uuid:this.loginForm.uuid}})
            }).catch(err => {
                this.handleGetLoginCode()//更新uuid生产验证码
                alert(err.response.data.error)
             });

      },
      goHome(){
          this.$router.push({name:'index'})
      },
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 简约*/
.bootstrap-frm {  max-width: 900px;}
.bootstrap-frm h1 { height:60px; line-height:60px; font-size:18px; border:none; padding:0; margin:0; color:#333;}
.bootstrap-frm label { width:48%; display: block; margin: 0px 0px 5px; padding-right:1.5%; float:left; }
.bootstrap-frm label span { float: left; width:90px; text-align: right; padding-right: 10px; margin-top: 10px;  font-weight: normal; font-size:16px; color:#333; }
.bootstrap-frm input[type="text"], 
.bootstrap-frm input[type="email"], 
.bootstrap-frm textarea, 
.bootstrap-frm select {width:300px; float:left; border: 1px solid #CCC; color: #888; height: 20px; line-height: 15px; margin-bottom: 16px; margin-right: 6px; margin-top: 2px; outline: 0 none; padding: 5px 0px 5px 5px;  border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px;  }
.bootstrap-frm select { background: #FFF no-repeat right; appearance: none; -webkit-appearance: none; -moz-appearance: none; text-indent: 0.01px; text-overflow: ''; width:300px; height: 35px; line-height: 15px; }
.bootstrap-frm textarea {  float:left;  height: 100px; padding: 5px 0px 0px 5px; width:300px; }
.bootstrap-frm .button { background: #FFF; color: #333; border-radius: 4px; }
.bootstrap-frm .button:hover { color: #333; background-color: #EBEBEB; }
.bootstrap-frm label img { width:90px; height:30px; float:left; padding-left:5px; }

.bootstrap-frm2 {  max-width: 900px;}
.bootstrap-frm2 h1 { height:60px; line-height:60px; font-size:18px; border:none; padding:0; margin:0; color:#333;}
.bootstrap-frm2 label { width:48%; display: block; margin: 0px 0px 5px; padding-right:1.5%; float:left; }
.bootstrap-frm2 label span { float: left; width:150px; text-align: right; padding-right: 10px; margin-top: 10px;  font-weight: normal; font-size:16px; color:#333; }
.bootstrap-frm2 label em { float: left; width:auto; text-align: right; padding-right: 10px; margin-top: 10px;  font-weight: normal; font-size:16px; color:#333; }
.bootstrap-frm2 input[type="text"], 
.bootstrap-frm2 input[type="email"], 
.bootstrap-frm2 textarea, 
.bootstrap-frm2 select {width:250px; float:left; border: 1px solid #CCC; color: #888; height: 20px; line-height: 15px; margin-bottom: 16px; margin-right: 6px; margin-top: 2px; outline: 0 none; padding: 5px 0px 5px 5px;  border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px;  }
.bootstrap-frm2 select {width:250px;  background: #FFF no-repeat right; appearance: none; -webkit-appearance: none; -moz-appearance: none; text-indent: 0.01px; text-overflow: ''; height: 35px; line-height: 15px; }
.bootstrap-frm2 textarea {width:250px;  float:left;  height: 100px; padding: 5px 0px 0px 5px;  }
.bootstrap-frm2 .button { background: #FFF; color: #333; border-radius: 4px; }
.bootstrap-frm2 .button:hover { color: #333; background-color: #EBEBEB; }
.bootstrap-frm2 label img {  width:auto; height:45px; float:left; padding-left:5px; }
</style>



// WEBPACK FOOTER //
// src/views/query.vue